module.exports = __webpack_public_path__ + "static/media/Raggruppa_73.31c2e673.svg";